export const safeLog = (...args: any[]) => {
  const sanitized = args.map(a =>
    typeof a === "string" ? a.replace(/[\r\n]/g, "") : a
  );
  console.log(...sanitized);
};